import type {
  Environment,
  Feature,
  FeatureToggle,
  FeatureToggles,
  FeatureTogglesMap,
  FeatureValue,
} from './types'

export const FEATURE_TOGGLES: FeatureTogglesMap = {
  mux: 'is-mux-enabled',
  localizationGPS: 'is-localization-verification-enabled',
  adsEnabled: 'is-ads-enabled',
  stationPassportDonation: 'is-station-passport-donation-enabled',
} as const

export const DEFAULT_FEATURE_TOGGLE_VALUES: {
  [key: string]: boolean | string
} = {
  [FEATURE_TOGGLES.mux]: false,
  [FEATURE_TOGGLES.localizationGPS]: false,
  [FEATURE_TOGGLES.adsEnabled]: true,
  [FEATURE_TOGGLES.stationPassportDonation]: false,
}

export const mapFeatureToggles = (configurations: any[]) =>
  configurations.map((c) => ({ key: c.name, value: c.value }))

export const findFeatureToggleValue = (
  feature: Feature,
  featureToggles: FeatureToggles = []
) => {
  const foundToggle = featureToggles.find((ft) => ft.key === feature)

  return foundToggle
    ? foundToggle.value
    : DEFAULT_FEATURE_TOGGLE_VALUES[feature]
}

export const findFeatureToggleValueAsync = async (
  featureTogglesPromise: Promise<FeatureToggle[]>,
  feature: Feature
): Promise<FeatureValue> => {
  try {
    const featureToggles = await featureTogglesPromise
    return findFeatureToggleValue(feature, featureToggles)
  } catch {
    return DEFAULT_FEATURE_TOGGLE_VALUES[feature]
  }
}

export const getEnvironment = (): Environment => {
  const currentUrl = window.location.href
  switch (true) {
    case currentUrl.includes('localhost'):
      return 'local'
    case currentUrl.includes('staging'):
      return 'staging'
    case currentUrl.includes('prod'):
      return 'prod'
    case currentUrl.includes('qa'):
      return 'qa'
    default:
      return 'dev'
  }
}
